module.exports = __webpack_public_path__ + "static/img/lab_2.f724529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lab_2.png
// module id = xTz2
// module chunks = 1